// external imports
import React from 'react';
import { Typography, Button } from '@mui/material';
import search from '../../assets/images/Rectangle.png';
import { Wrapper } from './Wrapper';
import { ImageContainer } from './ImageContainer';

// create component
function NoResults({ resetFilter }) {
  return (
    <Wrapper>
      <ImageContainer>
        <img src={search} alt="searching for results" />
      </ImageContainer>
      <Typography variant="h2">
        Keine Suchergebnisse gefunden
      </Typography>
      <Typography>
        Leider liefert die eingegebene Suche kein passendes Ergebnis.
      </Typography>
      <Typography>
        Ändern Sie einzelne Suchparameter oder setzen Sie alle Filter zurück.
      </Typography>
      <Button variant="outlined" onClick={resetFilter}>
        Alle Filter zurücksetzen
      </Button>
    </Wrapper>
  );
}

export default NoResults;
